import { AuraFilters } from '@/types/models/AuraFiltersModel';

export interface AuraAskRequest {
    question: string;
    conversationId?: number;
    filters?: AuraFilters;
    context?: Record<string, unknown>;
    availableAgents?: Array<{ id: number; name: string }>;
    availableQueues?: Array<{ id: number; name: string }>;
}
